import * as core from '../../../../../../../core'
import * as innovationTracker from '../innovation-tracker'

export const RESOURCE = {
  payload: {
    alias: 'innovation.dashboard',
    appAlias: innovationTracker.RESOURCE.payload.alias,
    description: "Evaluate progress towards Innovation's idea Goals",
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Idea Dashboard',
    page: { alias: 'innovation.dashboard' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
